import React, { useEffect } from 'react'
import { YStack, styled } from 'tamagui'
import { useNavigate } from 'react-router-dom'

import { GradientBackgroundScreen } from './Screen'
import { H1, Text } from './Text'
import { Button } from './Button/Button'
import { LogoIconAnimated } from './Logo/LogoIconAnimated'
import { useNotFound } from '@data/NotFoundContext'

const GradientHeading = styled(H1, {
  name: 'GradientHeading',

  style: {
    background: 'linear-gradient(135deg, #5533EB 0%, #6E33EB 50%, #FF627E 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },
})

export const NotFoundScreen = () => {
  const navigate = useNavigate()
  const notFoundContext = useNotFound()

  // Signal to the SSR context that this is a 404
  useEffect(() => {
    notFoundContext?.setNotFound()
  }, [])

  return (
    <GradientBackgroundScreen
      alignItems="center"
      justifyContent="center"
      paddingTop="$10"
      paddingBottom="$10"
      paddingHorizontal="$4"
      gap="$8"
    >
      <LogoIconAnimated animate width="$16" height="$16" />

      <YStack alignItems="center" gap="$4" maxWidth={360}>
        <GradientHeading size="$11" textAlign="center">
          Not found
        </GradientHeading>

        <Text size="$5" textAlign="center" color="$grey7" lineHeight="$6">
          The page you're looking for doesn't exist or has been moved.
        </Text>
      </YStack>

      <Button onPress={() => navigate('/')}>
        <Button.Text>Go Home</Button.Text>
      </Button>
    </GradientBackgroundScreen>
  )
}

export default NotFoundScreen
